import * as React from 'react'
import { Button } from '~/lib/ui/button'
import { useCoachDashboard } from '../../CoachDashboardProvider'

export function AvailabilityCell({ row }) {
  const event = row.original
  const { handleAvailabilityUpdate } = useCoachDashboard()

  return event.request?.available == null ? (
    <div className="flex gap-4">
      <Button
        variant="coachcta"
        onClick={() => handleAvailabilityUpdate(event.id, true)}
      >
        Available
      </Button>
      <Button
        variant="destructive"
        onClick={() => handleAvailabilityUpdate(event.id, false)}
      >
        Not Available
      </Button>
    </div>
  ) : event.request.available ? (
    <div className="text-intoo-green-coachcta">Marked Available</div>
  ) : (
    <div className="text-red-500">Marked Not Available</div>
  )
}
